import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import { useSelector } from 'react-redux';
import PriceSlider from './PriceSlider';

const PriceSliderPopover = ({ children }) => {
  const openSearchFilter = useSelector((state) => state.searchFilters.openSearchFilter);

  return (
    <Popover
      placement="bottomLeft"
      overlayClassName="daily-price-popover"
      content={<PriceSlider />}
      open={openSearchFilter === 'price'}
    >
      {children}
    </Popover>
  );
};

PriceSliderPopover.propTypes = {
  children: PropTypes.element.isRequired,
};

export default PriceSliderPopover;
